import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Rect from '@reach/rect';

import CtaBody from './CtaBody';

const CtaFooter = ({ on, setBannerOn }) => {
  const [isSSR, setSSR] = useState(true);

  useEffect(() => {
    setSSR(false);
  }, []);

  const handleChange = rect => {
    if (!window) return false;
    if (on && window.innerHeight > rect.bottom) {
      setBannerOn(false);
    } else {
      setBannerOn(true);
    }
    return false;
  };

  // console.log('rect, height: ', rect, height);
  if (isSSR) return <CtaBody />;

  return <Rect onChange={handleChange}>{({ ref }) => <CtaBody visibilityRef={ref} />}</Rect>;
};

CtaFooter.propTypes = {
  on: PropTypes.bool.isRequired,
  setBannerOn: PropTypes.func.isRequired,
};

export default CtaFooter;
